var lib_core = require("lib-core");
var _ = require("underscore");

var SettingsStateMachine = function (root, model) {
    var self = this;

    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(self);

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CHANGE_SETTING;
        },
        function(cEvent){
            self.root.rec();
            self.changeSetting(cEvent);
            self.root.stopRec();
            self.syncContentServer();
        }
    );

    this.addTransition("idle", "changing_setting",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.SETTINGS_FOCUS;
        },
        function(cEvent){
            self.root.rec();
        }
    );

    this.addTransition("changing_setting", "changing_setting",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CHANGE_SETTING;
        },
        function(cEvent){
            self.changeSetting(cEvent);
        }
    );

    this.addTransition("changing_setting", "changing_setting",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.SETTINGS_FOCUS;
        },
        function(cEvent){
            self.root.stopRec();    // stop previous changing property
            self.syncContentServer();
            self.root.rec();        // imediately start new record for changing property
        }
    );

    this.addTransition("changing_setting", "idle",
        function(cEvent){
            return !(   cEvent.type().isHoverAction ||
                        cEvent.type().isViewAction  ||
                        cEvent.type() == lib_core.GuiEvents.CHANGE_SETTING ||
                        cEvent.type() == lib_core.GuiEvents.SETTINGS_FOCUS   );
        },
        function(cEvent){
            self.root.stopRec();
            self.syncContentServer();
            self.handle(cEvent);
        }
    );

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.TOGGLE_PUBLICATION_STATUS;
        },
        function(cEvent){
            var assetId = self.root.header['assetId'];
            self.model.privateShadow(!self.model.privateShadow());
            var action = self.model.privateShadow() ? 'unpublish' : 'publish';
            self.root.dataLoader.dataManager.publishResource("library", assetId, action, true, true);
        }
    );


    this.verifySyncContentServer();
};

lib_core.inherit(SettingsStateMachine, lib_core.StateMachine);

module.exports = SettingsStateMachine;

SettingsStateMachine.prototype.changeSetting = function(cEvent) {
    var prop = cEvent.element().collections.get(cEvent.data('id')) || cEvent.element().shadows.get(cEvent.data('id'));
    prop.set(cEvent.data('value'));
};

//override if needed
SettingsStateMachine.prototype.verifySyncContentServer = function () {
    var self = this;
    var data = self.model.data;
    var header = this.root.header;
    var metaData = data.metaData();
    self.root.dataLoader.dataManager.getResource(header["assetType"], header["assetId"])
    .then(function(contentServerData){
        var outOfSync = false;

        try {
            if(contentServerData["name"] != metaData.name()) {
                outOfSync = true;
            }
            if(contentServerData["summary"] != metaData.summary().replace(/\n/g,' ')) {
                outOfSync = true;
            }
            if(contentServerData["description"] != metaData.description().replace(/\n/g,' ')) {
                outOfSync = true;
            }
            if(!_.isEqual(contentServerData["tags"], metaData.tags.toArray())) {
                outOfSync = true;
            }
            if(contentServerData["alias"] != metaData.alias()) {
                outOfSync = true;
            }
        } catch (err) {
            console.error(err);
            outOfSync = true;
        }

        if(outOfSync) {
            console.error("Content server out of sync with metadata in data model");
            //WARNING: Content server is delayed by a few seconds (updates of a previous session may not be reflected yet)
            // self.syncContentServer();
        }
    });
};

//override if needed
SettingsStateMachine.prototype.syncContentServer = function () {
    var self = this;
    var data = self.model.data;
    var header = this.root.header;
    var metaData = data.metaData();
    var resourceDescription = {
            name: metaData.name(),
            description: metaData.description(),
            summary: metaData.summary(),
            tags: metaData.tags.toArray(),
            alias: metaData.alias()
    };
    return self.root.dataLoader.dataManager.updateResource(header["assetType"], header["assetId"], resourceDescription)
    .then(function(){
        console.log("syncContentServer done");
    });
    console.log("syncContentServer");
};
